var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',_vm._l((_vm.request_data),function(req,indexReq){return _c('tr',[_c('td',[_vm._v(" "+_vm._s(indexReq)+" ")]),(typeof req === 'object')?_c('td',[_c('request_data',{attrs:{"request_data":req}})],1):_c('td',[_vm._v(" "+_vm._s(req)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }